import React from 'react'

export default ({ html }) => (
    <div dangerouslySetInnerHTML={{__html: html}} />
)